"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  reducers: true,
  Analytics: true,
  config: true,
  pluginLoader: true,
  NuiClient: true,
  RouteHandler: true,
  HttpCode: true,
  getPublicPath: true,
  parseConfig: true,
  nuiReduxMiddlewares: true,
  withSideBar: true,
  createBrowserRouter: true
};
Object.defineProperty(exports, "Analytics", {
  enumerable: true,
  get: function get() {
    return _Analytics.default;
  }
});
exports.HttpCode = void 0;
Object.defineProperty(exports, "NuiClient", {
  enumerable: true,
  get: function get() {
    return _NuiClient.default;
  }
});
Object.defineProperty(exports, "RouteHandler", {
  enumerable: true,
  get: function get() {
    return _RouteHandler.default;
  }
});
Object.defineProperty(exports, "config", {
  enumerable: true,
  get: function get() {
    return _config.default;
  }
});
Object.defineProperty(exports, "createBrowserRouter", {
  enumerable: true,
  get: function get() {
    return _createBrowserRouter.createBrowserRouter;
  }
});
Object.defineProperty(exports, "getPublicPath", {
  enumerable: true,
  get: function get() {
    return _cdn.getPublicPath;
  }
});
Object.defineProperty(exports, "nuiReduxMiddlewares", {
  enumerable: true,
  get: function get() {
    return _middleware.default;
  }
});
Object.defineProperty(exports, "parseConfig", {
  enumerable: true,
  get: function get() {
    return _parseConfig.default;
  }
});
Object.defineProperty(exports, "pluginLoader", {
  enumerable: true,
  get: function get() {
    return _pluginLoader.default;
  }
});
Object.defineProperty(exports, "reducers", {
  enumerable: true,
  get: function get() {
    return _reducers.default;
  }
});
Object.defineProperty(exports, "withSideBar", {
  enumerable: true,
  get: function get() {
    return _withSideBar.default;
  }
});
var _exenv = require("exenv");
var _reducers = _interopRequireDefault(require("./reducers"));
var _containers = require("./containers");
Object.keys(_containers).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _containers[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _containers[key];
    }
  });
});
var _Analytics = _interopRequireDefault(require("./components/Analytics"));
var _config = _interopRequireDefault(require("./config"));
var _pluginLoader = _interopRequireDefault(require("./util/pluginLoader"));
var _redux = require("./redux");
Object.keys(_redux).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _redux[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _redux[key];
    }
  });
});
var _NuiClient = _interopRequireDefault(require("./components/NuiClient"));
var _RouteHandler = _interopRequireDefault(require("./components/RouteHandler"));
var _HttpCode = _interopRequireWildcard(require("./httpCode"));
exports.HttpCode = _HttpCode;
var _UserAuthWrapper = require("./components/UserAuthWrapper");
Object.keys(_UserAuthWrapper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _UserAuthWrapper[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _UserAuthWrapper[key];
    }
  });
});
var _cdn = require("./util/cdn");
var _parseConfig = _interopRequireDefault(require("./util/parseConfig"));
var _middleware = _interopRequireDefault(require("./redux/middleware"));
var _withSideBar = _interopRequireDefault(require("./components/withSideBar"));
var _createBrowserRouter = require("./util/createBrowserRouter");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Set window.__INITIAL_STATE__ object from initial state html element from server
if (_exenv.canUseDOM) {
  if (!window.__INITIAL_STATE__) {
    var initialStateElement = document.getElementById('__initialState');
    if (initialStateElement) {
      window.__INITIAL_STATE__ = JSON.parse(initialStateElement.innerText);
    }
    require('./util/assign');
  }
}